import { render, staticRenderFns } from "./MailboxAdd.vue?vue&type=template&id=df56362a&scoped=true"
import script from "./MailboxAdd.vue?vue&type=script&lang=js"
export * from "./MailboxAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df56362a",
  null
  
)

export default component.exports